import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'auth/callback',
    loadComponent: () => import('./components/auth-callback/auth-callback.component').then(m => m.AuthCallbackComponent)
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./layouts/main-layout/main-layout.component').then(m => m.MainLayoutComponent),
    children: [
      {
        path: 'dashboard',
        // El titulo y el subtitulo se muestran en la cabecera, al lado de la
        // marca: se declaran aca y no en el componente.
        data: { titulo: 'Resumen de Portafolio', subtitulo: 'Proyectos asignados al gerente' },
        loadComponent: () => import('./modules/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'dashboard/resumen/:id/:name/:client/:serviceType',
        data: { titulo: 'Detalle del proyecto' },
        loadComponent: () => import('./modules/project-summary/project-summary.component').then(m => m.ProjectSummaryComponent)
      },
      {
        /* La misma pantalla, sabiendo solo el id.

           Los otros tres segmentos existen porque el listado los pasa por la
           url, pero la pantalla los vuelve a leer de la API igual. Sin esta
           ruta no se puede enlazar un proyecto desde ningun otro lado: una
           notificacion sabe el proyecto, no el cliente ni el tipo.

           **Va el id y no el codigo**: el codigo se repite entre sociedades
           (`ESFINA` existe en tres). Un link viejo con codigo sigue andando
           mientras el codigo nombre a un solo proyecto; si no, la API lo dice. */
        path: 'dashboard/resumen/:id',
        data: { titulo: 'Detalle del proyecto' },
        loadComponent: () => import('./modules/project-summary/project-summary.component').then(m => m.ProjectSummaryComponent)
      },
      {
        path: 'notificaciones',
        data: { titulo: 'Notificaciones', subtitulo: 'Lo que pide tu atención' },
        loadComponent: () => import('./modules/notificaciones/notificaciones.component').then(m => m.NotificacionesComponent)
      },
      {
        path: 'dashboard/resumen/:id/:name/:client/:serviceType/planificar-asignacion',
        data: { titulo: 'Planificar estimación' },
        loadComponent: () => import('./modules/shared-components/planificar-asignacion/planificar-asignacion.component').then(m => m.PlanificarAsignacionComponent)
      },
      {
        path: 'configuracion',
        data: { titulo: 'Configuración', subtitulo: 'Parámetros del sistema y equivalencias con ARMUS' },
        loadComponent: () => import('./modules/configuracion/configuracion.component').then(m => m.ConfiguracionComponent)
      },
      {
        path: 'usuarios',
        data: { titulo: 'Usuarios y roles', subtitulo: 'Quién ve y edita qué' },
        loadComponent: () => import('./modules/usuarios/usuarios.component').then(m => m.UsuariosComponent)
      },
      /* Las dos colas son dos rutas y no dos solapas: así el menú lateral
         puede llevarte directo a la que te interesa, y el enlace a un problema
         de envío abre donde está el problema. Es el mismo componente: lo que
         cambia es qué cola muestra. */
      {
        path: 'monitor',
        data: { titulo: 'Monitor de sincronización', cola: 'importamos' },
        loadComponent: () => import('./modules/sync-monitor/sync-monitor.component').then(m => m.SyncMonitorComponent)
      },
      {
        path: 'monitor/envios',
        data: { titulo: 'Monitor de sincronización', cola: 'enviamos' },
        loadComponent: () => import('./modules/sync-monitor/sync-monitor.component').then(m => m.SyncMonitorComponent)
      },
      /* El disparador del cierre mensual. Va al lado del monitor y no adentro:
         el monitor cuenta lo que ya pasó, esto hace que pase. */
      {
        path: 'cierre',
        data: { titulo: 'Cierre de período' },
        loadComponent: () => import('./modules/cierre/cierre.component').then(m => m.CierreComponent)
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
